import { render } from "./checkbox-base.vue?vue&type=template&id=16a54a7d&scoped=true"
import script from "./checkbox-base.vue?vue&type=script&lang=js"
export * from "./checkbox-base.vue?vue&type=script&lang=js"

import "./checkbox-base.vue?vue&type=style&index=0&id=16a54a7d&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a54a7d"]])

export default __exports__